const translations = {
    label: 'Select Drone'
};

export default translations;
